import styled from "styled-components";

export const TreeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 20px;
  margin: 20px;
  /* Navbar (46px) plus this container's own top and bottom margins */
  height: calc(100dvh - 86px);

  .tree-panel {
    width: 40%;
    border-right: 1px solid #e8e8e8;
    padding-right: 15px;
    height: 100%;
    display: flex;
    flex-direction: column;
    /* Without this a wide tree label grows the panel instead of scrolling inside it */
    min-width: 0;

    .ant-tree {
      flex: 1;
      overflow: auto;
    }
  }

  .details-panel {
    flex: 1;
    height: 100%;
    min-width: 0;

    .ant-card {
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .ant-card-body {
      flex: 1;
      overflow: auto;
    }
  }

  @media (max-width: 991px) {
    flex-direction: column;
    height: auto;

    .tree-panel {
      width: 100%;
      border-right: none;
      padding-right: 0;
      height: auto;

      .ant-tree {
        flex: none;
        overflow: visible;
      }
    }

    .details-panel {
      height: auto;

      .ant-card,
      .ant-card-body {
        height: auto;
        overflow: visible;
      }
    }
  }
`;

export const ActionsRow = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
`;

export const PublishedSpan = styled.span`
  background-color: #52c41a;
  color: white;
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 10px;
  margin-right: 4px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const UnpublishedSpan = styled.span`
  background-color: #faad14;
  color: white;
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 10px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const IsPublishedBadgeSpan = styled.span`
  margin-left: 8px;
  font-size: 11px;
  background: ${({ isPublished }) => (isPublished ? "#52c41a" : "#ff4d4f")};
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 500;
`;
